import Vue from 'vue'
import Router from 'vue-router'

// Components for routes
import Home from '@/components/Home'
import UserLogin from '@/components/user/UserLogin'
import UserLoginError from '@/components/user/UserLoginError'
import UserEdit from '@/components/user/UserEdit'
import UserCreate from '@/components/user/UserCreate'
import UserList from '@/components/user/UserList'
import Devices from '@/components/device/DeviceList'
import EnableDevices from '@/components/device/EnableDevices'
import Playlist from '@/components/playlist/PlaylistList'
import Media from '@/components/media/MediaList'
import Matrix from '@/components/errors/Matrix'
import Payments from '@/components/payments/PaymentsList'
import FindPayments from '@/components/payments/Find'
import Errors from '@/components/errors/ErrorsList'
import Reporterrors from '@/components/reports/Errors'
import Reportsales from '@/components/reports/Sales'
import FindDashboard from '@/components/dashboard/Find'
import FindDashboardReport from '@/components/dashboard/csv'
import NetworkList from '@/components/network/NetworkList'
import NetworkEdit from '@/components/network/NetworkEdit'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: true,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/login',
      name: 'userLogin',
      component: UserLogin
    },
    {
      path: '/login/error',
      name: 'userLoginError',
      component: UserLoginError
    },
    {
      path: '/user',
      name: 'userEdit',
      component: UserEdit,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/usercreate',
      name: 'userCreate',
      component: UserCreate,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/userlist',
      name: 'userList',
      component: UserList,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/devices/:type',
      name: 'devices',
      component: Devices,
      props: true,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/enabledevices',
      name: 'enabledevices',
      component: EnableDevices,
      props: true,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/matrix',
      name: 'matrix',
      component: Matrix,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/payments',
      name: 'payments',
      component: Payments,
      props: true,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/findpayments',
      name: 'findpayments',
      component: FindPayments,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
      props: true,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/playlists',
      name: 'playlists',
      component: Playlist,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/media',
      name: 'media',
      component: Media,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/reporterrors',
      name: 'reporterrors',
      component: Reporterrors,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/reportsales',
      name: 'reportsales',
      component: Reportsales,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: FindDashboard,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/dashboard-report',
      name: 'dashboard-report',
      component: FindDashboardReport,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/networklist',
      name: 'networklist',
      component: NetworkList,
      meta: {
        userOnly: true
      }
    },
    {
      path: '/network',
      name: 'networkEdit',
      component: NetworkEdit,
      meta: {
        networkOnly: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js